import styled from 'styled-components'

export const Title = styled.div`
  div {
    line-height: 32px;
    color: #213f68;
    font-weight: 700;
    font-family: Roboto;
  }
  .ant-divider {
    margin: 20px 0;
    background: #d9d9d9;
  }
`
